import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./View.module.sass";
import Table from "../Table";
import Panel from "./Panel";
import { getStoredCameras } from "../../../../../utils/cameraUtils";
import Card from "../../../../../components/Card";
import { get_all_cameras } from "../../../../../API/Camera";

const View = () => {
  const [visible, setVisible] = useState(false);
  const [cameras, setCamras] = useState([]);
  const navigate = useNavigate();
  const updateCamerasWithLocalStorage = async () => {
    try {
      const res = await get_all_cameras();
      const apiCameras = res.data;
      const storedCameras = getStoredCameras();
      const storedCamerasMap = new Map(
        storedCameras.map((camera) => [camera.id, camera])
      );

      const updatedCameras = apiCameras.map((camera) => {
        const storedCamera = storedCamerasMap.get(camera.id);
        return {
          ...camera,
          brand: storedCamera ? storedCamera.brand : "Not linked",
        };
      });

      return updatedCameras;
    } catch (error) {
      console.error("Error updating cameras with local storage data:", error);
      throw error;
    }
  };

  const fetchAllCamaras = async () => {
    const updatedCameras = await updateCamerasWithLocalStorage();
    setCamras(updatedCameras);
  };

  useEffect(() => {
    fetchAllCamaras();
  }, []);
  const handleOnClick = () => {
    navigate(`/settingsDashboard/Cameras/create`);
  };
  return (
    <>
      <Card className={cn(styles.card)} title="Camera" classTitle="title-green">
        <div className={styles.list}>
          <Table
            data={cameras}
            className={styles.table}
            activeTable={visible}
            setActiveTable={setVisible}
          />
        </div>
      </Card>
      <div className="fixed bottom-7 left-30 right-5">
        <Panel onCreateClick={handleOnClick} />
      </div>
    </>
  );
};

export default View;
